import { render, staticRenderFns } from "./VQLANCTP.vue?vue&type=template&id=16c18f66&scoped=true"
import script from "./VQLANCTP.vue?vue&type=script&lang=js"
export * from "./VQLANCTP.vue?vue&type=script&lang=js"
import style0 from "./VQLANCTP.vue?vue&type=style&index=0&id=16c18f66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c18f66",
  null
  
)

export default component.exports